import Vue from 'vue';
import appInquiriesCount from '@/plugins/graphql/queries/v2/inquiry/app-inquiries-count.gql';
/**
 * Component for fetching App Inquiries Count and Daily Average
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.18}
 */
export default Vue.extend({
    apollo: {
        appInquiriesCount: {
            query: appInquiriesCount,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                return data.averageDailyInquiries;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            appInquiriesCount: null,
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                appInquiriesCount: this.appInquiriesCount,
            });
        }
    },
});
